/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Item_Col_GrowerInputs */

const vi_pl_item_col_grower = /** @type {(inputs: Pl_Item_Col_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ bán`)
};

/**

* @param {Pl_Item_Col_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_item_col_grower = /** @type {((inputs?: Pl_Item_Col_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Item_Col_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_item_col_grower(inputs)
});